import React from "react";
import ReactDOM from "react-dom/client";
import "react-notifications/lib/notifications.css";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import "./index.scss";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"), {});
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
